import { FC } from 'react';
import { Button, ButtonProps } from 'primereact/button';
import c from 'clsx';
import styles from './RedesignButton.module.scss';

type Props = {
  className?: string;
  variation?: 'primary' | 'secondary' | 'danger';
  height?: number;
} & ButtonProps;

export const RedesignButton: FC<Props> = (props) => {
  const { variation, className, text } = props;
  const classNames = c(
    styles.button,
    {
      [styles.primary]: variation === 'primary',
      [styles.secondary]: variation === 'secondary',
      [styles.danger]: variation === 'danger',
      [styles.text]: text,
    },
    className,
  );
  return (
    <Button
      {...props}
      style={{ ...props.style, height: `${props.height}px` }}
      className={classNames}
    >
      {props.children}
    </Button>
  );
};
